import { FC, useEffect, useState, useRef } from 'react'
import {
  Container,
  HoveredContainer
} from './styles'
import { FlexDiv } from '../index'
import CircleActionButton from '../../../basic/CircleActionButton'
import { ExpiringPoliciesListData } from 'src/dtos/portal'
import { IoMdCheckmark } from 'react-icons/io'
import { TbMail } from 'react-icons/tb'
import { isValid, format } from 'date-fns'

interface ExpiringPoliciesListRowProps {
  rowData: ExpiringPoliciesListData;
  checked: boolean;
  onClick: (checked: number) => void;
  openAppDrawer: () => void;
}

const ExpiringPoliciesListRow: FC<ExpiringPoliciesListRowProps> = ({
  rowData,
  openAppDrawer,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  const columns = ['Applicant Name', 'Applicant Type', 'Policy Number', 'Policy Expiration', 'Reminders Sent']

  const formattedData = {
    policyKey: rowData?.policyKey,
    effectiveDate: rowData?.effectiveDate,
    expiryDate: rowData?.expiryDate,
    firmId: rowData?.firmId,
    firmName: rowData?.firmName,
    id: rowData?.renewalId || rowData?.applicationId,
    applicantName: rowData?.renewalApplicantName || rowData?.applicantName,
    applicantEmail: rowData?.renewalApplicantEmail || rowData?.applicantEmail,
    applicantType: rowData?.renewalApplicantType || rowData?.applicantType,
    remindedAt: rowData?.renewalApplicantRemindedAt || rowData?.applicantRemindedAt,
  }


  const handleContainerClick = () => {
    openAppDrawer()
  }

  useEffect(() => {
    if (!!containerRef && !!containerRef?.current) {
      containerRef.current.addEventListener('mouseenter', () => setIsHovered(true))
      containerRef.current.addEventListener('mouseleave', () => setIsHovered(false))
    }
  }, [containerRef])

  return (
    <Container ref={containerRef} onClick={handleContainerClick}>
      <table>
        <thead>
          <tr>
            {columns.map(column => (
              <th key={column}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{formattedData?.applicantName}</td>
            <td>{formattedData?.applicantType}</td>
            <td>{formattedData?.policyKey}</td>
            <td>
              {
                formattedData?.expiryDate &&
                  isValid(new Date(formattedData?.expiryDate)) ?
                  format(new Date(formattedData.expiryDate), 'MM/dd/yyyy') : ''
              }
            </td>
            <td>
              <FlexDiv gap="6px" align='center'>
                {!!formattedData?.remindedAt && isValid(new Date(formattedData?.remindedAt)) ? (
                  <>
                    <IoMdCheckmark />
                    {format(new Date(formattedData.remindedAt), 'MM/dd/yyyy')}
                  </>
                ) : null}
              </FlexDiv>
            </td>
          </tr>
        </tbody>
      </table>
      <HoveredContainer className={`${isHovered ? 'hovered' : ''}`}>
        <a href={`mailto:${formattedData.applicantEmail}`} style={{ textDecoration: 'none' }}>
          <CircleActionButton
            label="Contact"
            bg="#EFEFEF"
            onClick={e => e.stopPropagation()}
          >
            <TbMail />
          </CircleActionButton>
        </a>
      </HoveredContainer>
    </Container>
  )
}

export default ExpiringPoliciesListRow